import React from "react";

import useDailyMenu from "@apps/daily-menu/hooks/useDailyMenu";

import {useSiteConfig} from "@globals/SiteConfig";
import useCutoffTimes from "@globals/hooks/useCutoffTimes";
import {useUser} from "@globals/user";

import NomiconIcon from "@components/NomiconIcon";
import TransparentButton from "@components/TransparentButton";

import styles from "./WelcomeModal.scss";
import iconGoMobile from "./img/icon_go_mobile.svg";
import iconNotifications from "./img/icon_notifications.svg";
import iconOrderEarly from "./img/icon_order_early.svg";

type WelcomeModalProps = {
  onClose: () => void;
};

export default function WelcomeModal({
  onClose,
}: WelcomeModalProps): JSX.Element {
  const {isMainEatclubSite} = useSiteConfig();
  const {user} = useUser();
  const {selectedDate, selectedLocationId} = useDailyMenu();
  const {cutoffTimes} = useCutoffTimes({
    selectedDate,
    selectedLocation: selectedLocationId,
  });

  const title = isMainEatclubSite()
    ? `Welcome to Eat Club, ${user?.first_name}`
    : `Welcome, ${user?.first_name}!`;

  let orderByText = "For the next delivery window";
  if (cutoffTimes?.cutoff_days === 0) {
    orderByText = "For same day delivery";
  }
  if (cutoffTimes?.cutoff_days === 1) {
    orderByText = "For next day delivery";
  }

  return (
    <div>
      <div className={styles.modalHeader}>
        <TransparentButton
          aria-label="Close"
          onClick={onClose}
          className={styles.closeBtn}
        >
          <NomiconIcon icon="nomicon-dismiss" />
        </TransparentButton>
        <div className={styles.title}>{title}</div>
      </div>
      <div className={styles.content}>
        <div className={styles.section}>
          <div className={styles.sectionLeft}>
            <img
              src={iconOrderEarly}
              className={styles.welcomeModalIcon}
              alt=""
            />
          </div>
          <div className={styles.sectionRight}>
            <div className={styles.sectionTitle}>
              Order by {cutoffTimes?.order_cutoff}
            </div>
            <div className={styles.sectionDescription}>{orderByText}</div>
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.sectionLeft}>
            <img
              src={iconNotifications}
              className={styles.welcomeModalIcon}
              alt=""
            />
          </div>
          <div className={styles.sectionRight}>
            <div className={styles.sectionTitle}>Order up to a week ahead</div>
            <div className={styles.sectionDescription}>
              Before the most popular dishes sell out
            </div>
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.sectionLeft}>
            <img
              src={iconGoMobile}
              className={styles.welcomeModalIcon}
              alt=""
            />
          </div>
          <div className={styles.sectionRight}>
            <div className={styles.sectionTitle}>Go mobile</div>
            <div className={styles.sectionDescription}>
              Order and get delivery notifications on the go
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
